import {put,takeLatest,call} from 'redux-saga/effects';
import * as venueService from "../../../services/venueService";
import {
    GET_VENUES,
    GET_VENUES_SUCCESS,
    GET_VENUES_ERROR
}
    from "../../actions/venue";

function* getVenuesSaga(action) {
    try {
        const data=yield call(venueService.GetVenues,action.payload)
        yield put({
            type: GET_VENUES_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_VENUES_ERROR,error: error.data
        });
    }
}


export function* getVenuesSagaWatcher() {
    yield takeLatest(GET_VENUES,getVenuesSaga);
}